// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"29387893","215":"a7da07c8","387":"985da0dc","427":"38a0526a","822":"68e845ea"}[chunkId] + ".chunk.css";
};